module.exports = __webpack_public_path__ + "img/create-account.35b232d8.png";